export default __webpack_public_path__ + "static/img2@2x-2b294615ac81296813ec797066af46c1.jpg";